import { createCn } from 'shared-utils'

export const articleBoxesCn = createCn('article-boxes')
